export let license_key = 0

export const setLicenseKey = (key) => {
    license_key = key
}

export const getLicenseKey = () => {
    return license_key
}
